import {
    VideoRecordingsService,
    IVideoRecordingsService as IVideoRecordingsApiService
} from '@techsee/techsee-client-infra/lib/services/VideoRecordingsService';
import {TokenGetter} from '@techsee/techsee-client-infra/lib/services/RestApiService';
import {
    IVideoRecordingsService,
    IByCustomerIdParams,
    IByCustomerNumberParams
} from '../states/history/_contracts/HistoryServiceContracts';

/**
 * Adapter that wraps the new VideoRecordingsService from client-infra
 * while keeping the old interface for backwards compatibility
 */
export class TsAppVideoRecordingsService implements IVideoRecordingsService {
    private _videoRecordingsService: IVideoRecordingsApiService;

    constructor(apiUrl: string, authToken: TokenGetter) {
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        this._videoRecordingsService = new VideoRecordingsService(baseUrl, authToken);
    }

    async byCustomerId(params: IByCustomerIdParams): Promise<{data: any}> {
        const data = await this._videoRecordingsService.byCustomerId(params.params.customerId);
        return {data};
    }

    async byCustomerNumber(params: IByCustomerNumberParams): Promise<{data: any}> {
        const data = await this._videoRecordingsService.byCustomerNumber(params.params.customerNumber);
        return {data};
    }
}
